export default __webpack_public_path__ + "static/media/Powered-by-Gousto.07dfdbd7.svg";